// extracted by mini-css-extract-plugin
export default {"container":"A7wSGNaztd_T7IeOksRj"};